/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForAssessmentRunDetail extends models.ReportConfigurationForAssessmentRun {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForAssessmentRunDetail");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForAssessmentRunDetail.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForAssessmentRunDetail>): ReportConfigurationForAssessmentRunDetail {
        let obj = Object.assign(new ReportConfigurationForAssessmentRunDetail(), model);
        ReportConfigurationForAssessmentRunDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForAssessmentRunDetail>): ReportConfigurationForAssessmentRunDetail {
        if (!model) return null;
        return ReportConfigurationForAssessmentRunDetail.newInstance(<ReportConfigurationForAssessmentRunDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForAssessmentRunDetail) {
        if (!obj) return;

        models.ReportConfigurationForAssessmentRunDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForAssessmentRunDetail): boolean {
        if (models.ReportConfigurationForAssessmentRun.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForAssessmentRunDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
